<!-- Full page carousel with phone input at bottom -->
<div class="min-h-screen bg-gradient-to-b relative" [ngClass]="{
        'from-[#ffdc9d] to-[#fcca84]': activeCarouselIndex === 0,
        'from-[rgba(255,216,145,255)] to-[rgba(238,172,92,255)]': activeCarouselIndex !== 0
     }">
  <!-- Full Page Carousel -->
  <div class="h-screen relative">
    <!-- // get active carousel index  -->
    <p-carousel [value]="carouselImages" [numVisible]="1" [numScroll]="1" [autoplayInterval]="5000"
      (onPage)="onCarouselChange($event)"
      [showIndicators]="false" [showNavigators]="false" [circular]="true" class="h-full"
      styleClass="h-full flex flex-col">
      <ng-template pTemplate="item" let-image>
        <div class="relative h-full flex flex-col items-center justify-center min-h-0" style="height:100%;">
          <img [src]="image.url" [alt]="image.alt" class="w-full h-screen object-contain inset-0" style="z-index:1;">
        </div>
      </ng-template>
    </p-carousel>
  </div>

  <!-- Phone Input Embedded at Bottom -->
  <div class="absolute bottom-8 left-0 right-0 px-6">
    <div class="flex justify-center">
      <form class="relative" style="width: 340px;" (ngSubmit)="loginWithPhoneNumber()">
        @if(!otpSent) {
        <div class="container flex items-stretch p-2">
          <p-iftalabel class="flex-1">
            <input [inputMode]="'numeric'" size="small" pInputText id="phone_number_label" [formControl]="phoneNumber"
              autocomplete="off" class="w-full border-none rounded-md h-full"
              [style]="{'border-top-right-radius': '0px', 'border-bottom-right-radius': '0px'}" />
            <label for="phone_number_label">Phone Number</label>
          </p-iftalabel>
          <div class="w-16 flex items-stretch">
            <p-button icon="pi pi-arrow-right" [text]="true" type="submit" class="w-full h-full"
              styleClass="text-white w-full h-full"
              [style]="{'background': '#4D7935', 'width': '100%', 'height': '100%', 'border-top-left-radius': '0px', 'border-bottom-left-radius': '0px'}">
            </p-button>
          </div>
        </div>
        } @else {
        <div class="container flex flex-col items-center justify-center p-2 pb-6 bg-green-500 rounded-md">
          <label class="text-white text-sm text-left mb-2 ml-10 w-full" for="phone_number_label">Enter OTP sent to your
            phone
            number</label>
          <p-inputotp #inputOtp appNumericInputMode inputmode="numeric" [formControl]="otp" [length]="6"
            [integerOnly]="true" [autofocus]="true" />
          @if(errorMessage) {
          <div class="text-red-500 text-sm text-left my-2">{{errorMessage}}</div>
          }
          @if(isLoading) {
            <div class="text-white text-sm text-left my-2">Authenticating <i class="pi pi-spin pi-spinner"></i></div>
          }
        </div>
        }
      </form>
      <div id="recaptcha-container"></div>
    </div>
  </div>
</div>